import { createApp } from "vue";

const app = createApp({});

app.config.globalProperties._t = window._t;

export default app;
